export const enviromentalLawData =
  [
    {
      label: '대기관리권역의 대기환경개선에 관한 특별법',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=230779&lsId=013458&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '대기환경보전법',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=259223&lsId=001773&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '물환경보전법',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=259547&lsId=000166&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '미세먼지 저감 및 관리에 관한 특별법',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=258079&lsId=013159&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '소음·진동관리법',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=251733&lsId=000167&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '순환경제사회 전환 촉진법',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=251733&lsId=000167&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '악취방지법',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=249389&lsId=009680&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '자원의 절약과 재활용촉진에 관한 법률',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=258083&lsId=000155&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '잔류성유기오염물질 관리법',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=243003&lsId=010383&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '토양환경보전법',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=246015&lsId=000160&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '폐기물관리법',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=259565&lsId=001771&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '화학물질관리법',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=259899&lsId=000162&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '화학물질의 등록 및 평가 등에 관한 법률',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=258085&lsId=011857&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '환경범죄 등의 단속 및 가중처벌에 관한 법률',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=247511&lsId=001143&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '환경오염시설의 통합관리에 관한 법률',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=254091&lsId=012414&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '환경오염피해 배상책임 및 구제에 관한 법률',
      url: 'https://www.law.go.kr/lsInfoP.do?lsiSeq=250007&lsId=012198&chrClsCd=010202&urlMode=lsEfInfoR&viewCls=thdCmpNewScP&ancYnChk=0#',
    },
    {
      label: '직접입력',
      url: '',
    }
  ]

export const valueEnviromentalLawDatas = () => {
  return enviromentalLawData.map((law) => {
    return law.label
  })
}

export const valueEnviromentalLawFilters = () => {
  return enviromentalLawData
    .filter((law) => law.label !== '직접입력')
    .map((law) => {
      return law.label
    })
}
